import { useState } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  OpenConvIcon,
  MobileIconWithoutNotif,
  EnvelopeIcon,
  UserCircle,
} from 'assets/icons';
import styles from './styles.module.scss';
import AvatarFallBack from 'assets/icons/user.svg';
import {
  openConversationForTheUser,
  updateUserAbout,
} from 'redux/convsArchive/convsArchive.actions';
import { Button } from 'components';
import useTranslation from 'hooks/useTranslation';
import NoteCard from '../NoteCard';

function UserInfo({ data }) {
  const { conversationId } = useParams();
  // const aboutInputRef = useRef();
  const [aboutFormValue, setAboutFormValue] = useState(data.about);
  const dispatch = useDispatch();

  const { getTranslation } = useTranslation('ARCHIVE');
  const { t } = getTranslation();

  const userInfoItems = [
    { title: t('CONV_DETAIL_LAST_PAGE'), key: 'lastVisitedPage', isLink: true },
    { title: t('CONV_DETAIL_IP'), key: 'ip' },
    { title: t('CONV_DETAIL_BROWSER'), key: 'browser' },
    { title: t('CONV_DETAIL_BROWSER_VERSION'), key: 'browserVersion' },
    { title: t('CONV_DETAIL_MOBILE_USER'), key: 'isUserOnMobile' },
    { title: t('CONV_DETAIL_OS'), key: 'os' },
    { title: t('CONV_DETAIL_REFERRER'), key: 'referrer', isLink: true },
  ];

  const handleClickOpenConversation = () => {
    dispatch(openConversationForTheUser(conversationId));
  };

  const renderInfoItemValue = (value, isLink) => {
    if (!value) return '-';

    if (isLink) {
      return (
        <a rel='noreferrer' href={value} target='_blank'>
          {value}
        </a>
      );
    }

    return value;
  };

  const renderDetails = userInfoItems.map((item) => (
    <div className={styles.user_detail_item}>
      <span className={styles.title}>{item.title}</span>
      <div className={styles.value}>
        {renderInfoItemValue(data[item.key], item.isLink)}
      </div>
    </div>
  ));

  const handleEnterClick = () => {
    // const aboutValue = aboutInputRef.current.value;
    if (data.about !== aboutFormValue) {
      dispatch(updateUserAbout({ about: aboutFormValue, userId: data.userId }));
    }
  };

  const handleChangeAboutField = (e) => {
    setAboutFormValue(e.target.value);
  };

  const handleDiscardChanges = () => {
    setAboutFormValue(data.about);
  };

  return (
    <>
      {/* user's overview */}
      <div className={styles.user_overview}>
        <div className={styles.user_overview__top}>
          {/* avatar */}
          <div className={styles.name_and_avatar}>
            {data.isUserOnline && <span className={styles.online_badge}></span>}
            <img
              className={styles.user_avatar}
              src={data.avatar}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = AvatarFallBack;
              }}
              alt=''
            />
            <span className={styles.user_title}>{data.name}</span>
          </div>
          <Button
            onClick={handleClickOpenConversation}
            className={styles.open_conv_btn}
          >
            <img
              className={styles.open_conv_btn__icon}
              src={OpenConvIcon}
              alt=''
            />
            <span>{t('OPEN_CONV_BTN_LABEL')}</span>
          </Button>
        </div>

        {/* email and phone number */}
        <div className={styles.user_overview__bottom}>
          <div className={styles.collection}>
            <img
              className={styles.collection__icon}
              src={MobileIconWithoutNotif}
              alt=''
            />
            <a
              className={styles.collection__phone_num}
              href={`tel:${data.phone}`}
            >
              {data.phone}
            </a>
          </div>
          <div className={styles.collection}>
            <img
              className={styles.collection__icon}
              src={EnvelopeIcon}
              alt=''
            />
            <a href={`mailto:${data.email}`}>{data.email}</a>
          </div>
        </div>
      </div>
      {/* user's details */}
      <div>
        <div className='flex flex-ai-c'>
          <img src={UserCircle} alt='' />
          <span className={styles.about_user__title}>{t('ABOUT_USER')}</span>
        </div>

        {/* device,os and other details */}
        <div className={styles.about_note}>
          <NoteCard
            handleSubmitChanges={handleEnterClick}
            handleDiscardChanges={handleDiscardChanges}
            handleChangeInput={handleChangeAboutField}
            value={aboutFormValue}
          />
        </div>
        <div className='flex flex-column'>{renderDetails}</div>
      </div>
    </>
  );
}

export default UserInfo;
